import colors from "vuetify/lib/util/colors";
export const other_settings =  {
  line_empty_dataset:
  {
    label: '',
    yAxisID:1,
    fill: false,
    data: { labels: null, datasets: []},
    shadowOffsetX: 3,
    shadowOffsetY: 3,
    shadowBlur: 10,
    shadowColor: "rgba(103, 116, 132, 0.5)",
    pointRadius: 4,
    pointBevelWidth: 3,
    pointHoverRadius: 6,
    pointHoverBevelWidth: 4.5,
    pointHoverInnerGlowWidth: 20,
    pointHoverInnerGlowColor: `rgba(103, 116, 132, 0.5)`,
    gradientStroke: [colors.green.lighten2, colors.green.lighten2],
  },
  line_option: 
  {
    responsive: true,
    scaleOverride: true,
    maintainAspectRatio: false,
    tooltips: {
      mode: "nearest",
      backgroundColor:'rgba(255,255,255,0.85)',
      titleFontColor:'#333',
      bodyFontColor: '#333',
      xPadding:15,
      yPadding:15,
      intersect: true,
    },
    hover: {
      mode: "nearest",
      intersect: false,
    },
    legend: {
      display: true,
      position:'bottom',
      align: 'start',
      labels:{
        boxWidth: 5,
        usePointStyle: true,
        fontColor:'white'
      },
      intersect: false,
    },
    layout: {
      padding: {
        left: 10,
        right: 10,
        bottom: 10,
        top: 10,
      },
    },
    scales: {
      xAxes: [
        {
          gridLines: {
            display: true,
            color:'#999'
          },
          scaleLabel:{
            color:'white'
          }
        }
      ],
      yAxes: [
        {
         id:1,
         stacked: true,
         fontColor:'white',
         position: 'left',
         display: true,
         zeroLineWidth: 1,
         scalePositionLeft: true,
         ticks: {
            beginAtZero: true
          },
          gridLines: {
            offsetGridLines: false,
            color:'white'
          },
          scaleLabel:{
            fontColor:'white'
          }
        }/*,
        {
          id:2,
          position:'right',
          display: true,
          ticks:{
            beginAtZero: true
          },
          gridLines: {
            drawBorder: false,
            drawTicks: false,
              
            color: '#E2E2F7',
            borderDash: [3,3],
            borderDashOffset: 0.5,
            zeroLineColor: '#E2E2F7',
            zeroLineBorderDash: [3,3],
            zeroLineWidth: 3,
            lineWidth: 3,
            cornerRadius: 2,
          }
        } */        
      ]
    }
  },
  bar_empty_dataset:
  {
    label: '',
    yAxisID:1,
    fill: false,
    data: { labels: null, datasets: []},
    shadowOffsetX: 3,
    shadowOffsetY: 3,
    shadowBlur: 10,
    shadowColor: "rgba(103, 116, 132, 0.5)",
    pointRadius: 4,
    pointBevelWidth: 3,
    pointHoverRadius: 6,
    pointHoverBevelWidth: 4.5,
    pointHoverInnerGlowWidth: 20,
    pointHoverInnerGlowColor: `rgba(103, 116, 132, 0.5)`,
    //gradientStroke: [colors.green.lighten2, colors.green.lighten2],
  },
  bar_option: 
  {
    responsive: true,
    scaleOverride: true,
    maintainAspectRatio: false,
    tooltips: {
      mode: "index",
      backgroundColor:'rgba(255,255,255,0.85)',
      titleFontColor:'#333',
      bodyFontColor: '#333',
      xPadding:15,
      yPadding:15,
      intersect: false,
    },
    hover: {
      mode: "nearest",
      intersect: false,
    },
    animation:{
      easing: 'easeOutBounce',
    },    
    legend: {
      display: true,
      position:'bottom',
      align: 'center',
      fontColor:'white',
      labels:{
        boxWidth: 5,
        usePointStyle: false,
        fontColor:'white'
      },
      intersect: false,
    },
    layout: {
      padding: {
        left: 10,
        right: 10,
        bottom: 10,
        top: 10,
      },
    },
    scales: {
      xAxes: [
        {
          stacked: true,
          title:{
            color:'white'
          },
          fontColor:'#FFF',
          ticks: {
            display:true,
            fontColor:'#FFF'
          },          
          gridLines: {
            display: true,
            color:'#555'
          },
          scaleLabel:{
            fontColor:'white'
          },
          zeroLineWidth: 1,
        }
      ],
      yAxes: [
        {
         id:1,
         stacked: false,
         title:{
          color:'white'
        },         
         position: 'left',
         display: true,
         zeroLineWidth: 1,
         fontColor:'white',
         scalePositionLeft: true,
         ticks: {
            beginAtZero: true,
            fontColor:'#FFF'
          },
          gridLines: {
            offsetGridLines: false,
            color:'#555'
          },
          scaleLabel:{
            fontColor:'white'
          }
        }/*,
        {
          id:2,
          position:'right',
          scalePositionLeft: false,
          display: true,
          ticks:{
            beginAtZero: true
          },
          gridLines: {
            drawBorder: false,
            drawTicks: false,
              
            color: '#E2E2F7',
            borderDash: [3,3],
            borderDashOffset: 0.5,
            zeroLineColor: '#E2E2F7',
            zeroLineBorderDash: [3,3],
            zeroLineWidth: 3,
            lineWidth: 3,
            cornerRadius: 2,
          }
        }  */       
      ]
    }
  },
  doughnut_empty_dataset:
  {
    label: '',
    fill: false,
    data: { labels: null, datasets: []},
    shadowOffsetX: 3,
    shadowOffsetY: 3,
    shadowBlur: 10,
    shadowColor: "rgba(103, 116, 132, 0.5)",
    pointRadius: 4,
    pointBevelWidth: 3,
    pointHoverRadius: 6,
    pointHoverBevelWidth: 4.5,
    pointHoverInnerGlowWidth: 20,
    pointHoverInnerGlowColor: `rgba(103, 116, 132, 0.5)`,
    gradientStroke: [colors.green.lighten2, colors.green.lighten2],
  },
  doughnut_option: 
  {
    responsive: true,
    scaleOverride: true,
    maintainAspectRatio: false,
    tooltips: {
      mode: "index",
      backgroundColor:'rgba(255,255,255,0.85)',
      titleFontColor:'#333',
      bodyFontColor: '#333',
      xPadding:15,
      yPadding:15,
      intersect: true,
    },
    hover: {
      mode: "index",
      intersect: false,
    },
    legend: {
      display: false,
      position: 'right',
      fontColor:'white',
      labels: {
        fontColor:'white',
        padding: 30, // ✅ More space between legend items and chart
        boxWidth: 10, // ✅ Increases the size of the color box (default is 10)
        usePointStyle: false, // ✅ Ensures proper alignment
        //fontSize: 14, // (Optional) Adjust for better readability
      },
    },
    title: {
			display: false,
			text: '',
      fontSize: 24
		},
    layout: {
      padding: {
        top: 5, // ✅ Reduce top padding (less space above chart)
        bottom: 10, // ✅ Increase bottom padding (more space for legend)
      },
    },
  },
}